export default "__VITE_ASSET__ODxYrQ9M__"